module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/deploy.ca22a3f9.svg";